var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");
var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");
var _get = require("/opt/build/repo/node_modules/@babel/runtime/helpers/get.js");
var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");
var _excluded = ["refetchPage"],
  _excluded2 = ["pageParam"],
  _excluded3 = ["pageParam"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
require("core-js/modules/esnext.global-this.js");
require("core-js/modules/es.object.from-entries.js");
require("core-js/modules/es.array.flat-map.js");
require("core-js/modules/es.array.unscopables.flat-map.js");
/**
 * react-query
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
!function (t, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("react"), require("use-sync-external-store/shim")) : "function" == typeof define && define.amd ? define(["exports", "react", "use-sync-external-store/shim"], e) : e((t = "undefined" != typeof globalThis ? globalThis : t || self).ReactQuery = {}, t.React, t.shim);
}(this, function (t, e, s) {
  "use strict";

  function r(t) {
    if (t && t.__esModule) return t;
    var e = Object.create(null);
    return t && Object.keys(t).forEach(function (s) {
      if ("default" !== s) {
        var r = Object.getOwnPropertyDescriptor(t, s);
        Object.defineProperty(e, s, r.get ? r : {
          enumerable: !0,
          get: function get() {
            return t[s];
          }
        });
      }
    }), e.default = t, Object.freeze(e);
  }
  var i = r(e);
  /**
     * query-core
     *
     * Copyright (c) TanStack
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE.md file in the root directory of this source tree.
     *
     * @license MIT
     */
  var n = /*#__PURE__*/function () {
    function n() {
      _classCallCheck(this, n);
      this.listeners = [], this.subscribe = this.subscribe.bind(this);
    }
    _createClass(n, [{
      key: "subscribe",
      value: function subscribe(t) {
        var _this = this;
        return this.listeners.push(t), this.onSubscribe(), function () {
          _this.listeners = _this.listeners.filter(function (e) {
            return e !== t;
          }), _this.onUnsubscribe();
        };
      }
    }, {
      key: "hasListeners",
      value: function hasListeners() {
        return this.listeners.length > 0;
      }
    }, {
      key: "onSubscribe",
      value: function onSubscribe() {}
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {}
    }]);
    return n;
  }();
  var o = "undefined" == typeof window;
  function a() {}
  function u(t) {
    return "number" == typeof t && t >= 0 && t !== 1 / 0;
  }
  function c(t, e) {
    return t.filter(function (t) {
      return -1 === e.indexOf(t);
    });
  }
  function h(t, e) {
    return Math.max(t + (e || 0) - Date.now(), 0);
  }
  function l(t, e, s) {
    return Q(t) ? "function" == typeof e ? _objectSpread(_objectSpread({}, s), {}, {
      queryKey: t,
      queryFn: e
    }) : _objectSpread(_objectSpread({}, e), {}, {
      queryKey: t
    }) : t;
  }
  function d(t, e, s) {
    return Q(t) ? "function" == typeof e ? _objectSpread(_objectSpread({}, s), {}, {
      mutationKey: t,
      mutationFn: e
    }) : _objectSpread(_objectSpread({}, e), {}, {
      mutationKey: t
    }) : "function" == typeof t ? _objectSpread(_objectSpread({}, e), {}, {
      mutationFn: t
    }) : _objectSpread({}, t);
  }
  function f(t, e, s) {
    return Q(t) ? [_objectSpread(_objectSpread({}, e), {}, {
      queryKey: t
    }), s] : [t || {}, e];
  }
  function p(t, e, s) {
    return Q(t) ? [_objectSpread(_objectSpread({}, e), {}, {
      mutationKey: t
    }), s] : [t || {}, e];
  }
  function y(t, e) {
    var _t$type = t.type,
      s = _t$type === void 0 ? "all" : _t$type,
      r = t.exact,
      i = t.fetchStatus,
      n = t.predicate,
      o = t.queryKey,
      a = t.stale;
    if (Q(o)) if (r) {
      if (e.queryHash !== m(o, e.options)) return !1;
    } else if (!g(e.queryKey, o)) return !1;
    if ("all" !== s) {
      var _t = e.isActive();
      if ("active" === s && !_t) return !1;
      if ("inactive" === s && _t) return !1;
    }
    return ("boolean" != typeof a || e.isStale() === a) && (void 0 === i || i === e.state.fetchStatus) && !(n && !n(e));
  }
  function v(t, e) {
    var s = t.exact,
      r = t.fetching,
      i = t.predicate,
      n = t.mutationKey;
    if (Q(n)) {
      if (!e.options.mutationKey) return !1;
      if (s) {
        if (b(e.options.mutationKey) !== b(n)) return !1;
      } else if (!g(e.options.mutationKey, n)) return !1;
    }
    return ("boolean" != typeof r || "loading" === e.state.status === r) && !(i && !i(e));
  }
  function m(t, e) {
    return ((null == e ? void 0 : e.queryKeyHashFn) || b)(t);
  }
  function b(t) {
    return JSON.stringify(t, function (t, e) {
      return S(e) ? Object.keys(e).sort().reduce(function (t, s) {
        return t[s] = e[s], t;
      }, {}) : e;
    });
  }
  function g(t, e) {
    return O(t, e);
  }
  function O(t, e) {
    return t === e || typeof t == typeof e && !(!t || !e || "object" != typeof t || "object" != typeof e) && !Object.keys(e).some(function (s) {
      return !O(t[s], e[s]);
    });
  }
  function C(t, e) {
    if (t === e) return t;
    var s = q(t) && q(e);
    if (s || S(t) && S(e)) {
      var _r = s ? t.length : Object.keys(t).length,
        _i = s ? e : Object.keys(e),
        _n = _i.length,
        _o = s ? [] : {};
      var _a = 0;
      for (var _r2 = 0; _r2 < _n; _r2++) {
        var _n2 = s ? _r2 : _i[_r2];
        _o[_n2] = C(t[_n2], e[_n2]), _o[_n2] === t[_n2] && _a++;
      }
      return _r === _n && _a === _r ? t : _o;
    }
    return e;
  }
  function R(t, e) {
    if (t && !e || e && !t) return !1;
    for (var _s in t) {
      if (t[_s] !== e[_s]) return !1;
    }
    return !0;
  }
  function q(t) {
    return Array.isArray(t) && t.length === Object.keys(t).length;
  }
  function S(t) {
    if (!P(t)) return !1;
    var e = t.constructor;
    if (void 0 === e) return !0;
    var s = e.prototype;
    return !!P(s) && !!s.hasOwnProperty("isPrototypeOf");
  }
  function P(t) {
    return "[object Object]" === Object.prototype.toString.call(t);
  }
  function Q(t) {
    return Array.isArray(t);
  }
  function E(t) {
    return new Promise(function (e) {
      setTimeout(e, t);
    });
  }
  function x(t) {
    E(0).then(t);
  }
  function M(t, e, s) {
    return null != s.isDataEqual && s.isDataEqual(t, e) ? t : "function" == typeof s.structuralSharing ? s.structuralSharing(t, e) : !1 !== s.structuralSharing ? C(t, e) : e;
  }
  var w = new ( /*#__PURE__*/function (_n3) {
    _inherits(_class, _n3);
    var _super = _createSuper(_class);
    function _class() {
      var _this2;
      _classCallCheck(this, _class);
      _this2 = _super.call(this), _this2.setup = function (t) {
        if (!o && window.addEventListener) {
          var _e = function _e() {
            return t();
          };
          return window.addEventListener("visibilitychange", _e, !1), window.addEventListener("focus", _e, !1), function () {
            window.removeEventListener("visibilitychange", _e), window.removeEventListener("focus", _e);
          };
        }
      };
      return _this2;
    }
    _createClass(_class, [{
      key: "onSubscribe",
      value: function onSubscribe() {
        this.cleanup || this.setEventListener(this.setup);
      }
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {
        var t;
        this.hasListeners() || (null == (t = this.cleanup) || t.call(this), this.cleanup = void 0);
      }
    }, {
      key: "setEventListener",
      value: function setEventListener(t) {
        var _this3 = this;
        var e;
        this.setup = t, null == (e = this.cleanup) || e.call(this), this.cleanup = t(function (t) {
          "boolean" == typeof t ? _this3.setFocused(t) : _this3.onFocus();
        });
      }
    }, {
      key: "setFocused",
      value: function setFocused(t) {
        this.focused = t, t && this.onFocus();
      }
    }, {
      key: "onFocus",
      value: function onFocus() {
        this.listeners.forEach(function (t) {
          t();
        });
      }
    }, {
      key: "isFocused",
      value: function isFocused() {
        return "boolean" == typeof this.focused ? this.focused : "undefined" == typeof document || [void 0, "visible", "prerender"].includes(document.visibilityState);
      }
    }]);
    return _class;
  }(n))();
  var F = new ( /*#__PURE__*/function (_n4) {
    _inherits(_class2, _n4);
    var _super2 = _createSuper(_class2);
    function _class2() {
      var _this4;
      _classCallCheck(this, _class2);
      _this4 = _super2.call(this), _this4.setup = function (t) {
        if (!o && window.addEventListener) {
          var _e2 = function _e2() {
            return t();
          };
          return window.addEventListener("online", _e2, !1), window.addEventListener("offline", _e2, !1), function () {
            window.removeEventListener("online", _e2), window.removeEventListener("offline", _e2);
          };
        }
      };
      return _this4;
    }
    _createClass(_class2, [{
      key: "onSubscribe",
      value: function onSubscribe() {
        this.cleanup || this.setEventListener(this.setup);
      }
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {
        var t;
        this.hasListeners() || (null == (t = this.cleanup) || t.call(this), this.cleanup = void 0);
      }
    }, {
      key: "setEventListener",
      value: function setEventListener(t) {
        var _this5 = this;
        var e;
        this.setup = t, null == (e = this.cleanup) || e.call(this), this.cleanup = t(function (t) {
          "boolean" == typeof t ? _this5.setOnline(t) : _this5.onOnline();
        });
      }
    }, {
      key: "setOnline",
      value: function setOnline(t) {
        this.online = t, t && this.onOnline();
      }
    }, {
      key: "onOnline",
      value: function onOnline() {
        this.listeners.forEach(function (t) {
          t();
        });
      }
    }, {
      key: "isOnline",
      value: function isOnline() {
        return "boolean" == typeof this.online ? this.online : "undefined" == typeof navigator || void 0 === navigator.onLine || navigator.onLine;
      }
    }]);
    return _class2;
  }(n))();
  function A(t) {
    return Math.min(1e3 * Math.pow(2, t), 3e4);
  }
  function D(t) {
    return "online" !== (null != t ? t : "online") || F.isOnline();
  }
  var U = /*#__PURE__*/_createClass(function U(t) {
    _classCallCheck(this, U);
    this.revert = null == t ? void 0 : t.revert, this.silent = null == t ? void 0 : t.silent;
  });
  function I(t) {
    return t instanceof U;
  }
  function T(t) {
    var e,
      s,
      r,
      i = !1,
      n = 0,
      o = !1;
    var a = new Promise(function (t, e) {
        s = t, r = e;
      }),
      u = function u() {
        return !w.isFocused() || "always" !== t.networkMode && !F.isOnline();
      },
      c = function c(r) {
        o || (o = !0, null == t.onSuccess || t.onSuccess(r), null == e || e(), s(r));
      },
      h = function h(s) {
        o || (o = !0, null == t.onError || t.onError(s), null == e || e(), r(s));
      },
      l = function l() {
        return new Promise(function (s) {
          e = function e(t) {
            if (o || !u()) return s(t);
          }, null == t.onPause || t.onPause();
        }).then(function () {
          e = void 0, o || null == t.onContinue || t.onContinue();
        });
      },
      d = function d() {
        if (o) return;
        var e;
        try {
          e = t.fn();
        } catch (t) {
          e = Promise.reject(t);
        }
        Promise.resolve(e).then(c).catch(function (e) {
          var s, r;
          if (o) return;
          var a = null != (s = t.retry) ? s : 3,
            c = null != (r = t.retryDelay) ? r : A,
            f = "function" == typeof c ? c(n, e) : c,
            p = !0 === a || "number" == typeof a && n < a || "function" == typeof a && a(n, e);
          !i && p ? (n++, null == t.onFail || t.onFail(n, e), E(f).then(function () {
            if (u()) return l();
          }).then(function () {
            i ? h(e) : d();
          })) : h(e);
        });
      };
    return D(t.networkMode) ? d() : l().then(d), {
      promise: a,
      cancel: function cancel(e) {
        o || (h(new U(e)), null == t.abort || t.abort());
      },
      continue: function _continue() {
        null == e || e();
      },
      cancelRetry: function cancelRetry() {
        i = !0;
      },
      continueRetry: function continueRetry() {
        i = !1;
      }
    };
  }
  var K = console;
  var k = function () {
    var t = [],
      e = 0,
      s = function s(t) {
        t();
      },
      r = function r(t) {
        t();
      };
    var i = function i(r) {
        e ? t.push(r) : x(function () {
          s(r);
        });
      },
      n = function n() {
        var e = t;
        t = [], e.length && x(function () {
          r(function () {
            e.forEach(function (t) {
              s(t);
            });
          });
        });
      };
    return {
      batch: function batch(t) {
        var s;
        e++;
        try {
          s = t();
        } finally {
          e--, e || n();
        }
        return s;
      },
      batchCalls: function batchCalls(t) {
        return function () {
          for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
            e[_key] = arguments[_key];
          }
          i(function () {
            t.apply(void 0, e);
          });
        };
      },
      schedule: i,
      setNotifyFunction: function setNotifyFunction(t) {
        s = t;
      },
      setBatchNotifyFunction: function setBatchNotifyFunction(t) {
        r = t;
      }
    };
  }();
  var L = /*#__PURE__*/function () {
    function L() {
      _classCallCheck(this, L);
    }
    _createClass(L, [{
      key: "destroy",
      value: function destroy() {
        this.clearGcTimeout();
      }
    }, {
      key: "scheduleGc",
      value: function scheduleGc() {
        var _this6 = this;
        this.clearGcTimeout(), u(this.cacheTime) && (this.gcTimeout = setTimeout(function () {
          _this6.optionalRemove();
        }, this.cacheTime));
      }
    }, {
      key: "updateCacheTime",
      value: function updateCacheTime(t) {
        this.cacheTime = Math.max(this.cacheTime || 0, null != t ? t : o ? 1 / 0 : 3e5);
      }
    }, {
      key: "clearGcTimeout",
      value: function clearGcTimeout() {
        this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
      }
    }]);
    return L;
  }();
  var j = /*#__PURE__*/function (_L) {
    _inherits(j, _L);
    var _super3 = _createSuper(j);
    function j(t) {
      var _this7;
      _classCallCheck(this, j);
      _this7 = _super3.call(this), _this7.abortSignalConsumed = !1, _this7.defaultOptions = t.defaultOptions, _this7.setOptions(t.options), _this7.observers = [], _this7.cache = t.cache, _this7.logger = t.logger || K, _this7.queryKey = t.queryKey, _this7.queryHash = t.queryHash, _this7.initialState = t.state || function (t) {
        var e = "function" == typeof t.initialData ? t.initialData() : t.initialData,
          s = void 0 !== t.initialData ? "function" == typeof t.initialDataUpdatedAt ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0,
          r = void 0 !== e;
        return {
          data: e,
          dataUpdateCount: 0,
          dataUpdatedAt: r ? null != s ? s : Date.now() : 0,
          error: null,
          errorUpdateCount: 0,
          errorUpdatedAt: 0,
          fetchFailureCount: 0,
          fetchMeta: null,
          isInvalidated: !1,
          status: r ? "success" : "loading",
          fetchStatus: "idle"
        };
      }(_this7.options), _this7.state = _this7.initialState, _this7.meta = t.meta;
      return _this7;
    }
    _createClass(j, [{
      key: "setOptions",
      value: function setOptions(t) {
        this.options = _objectSpread(_objectSpread({}, this.defaultOptions), t), this.meta = null == t ? void 0 : t.meta, this.updateCacheTime(this.options.cacheTime);
      }
    }, {
      key: "optionalRemove",
      value: function optionalRemove() {
        this.observers.length || "idle" !== this.state.fetchStatus || this.cache.remove(this);
      }
    }, {
      key: "setData",
      value: function setData(t, e) {
        var s = M(this.state.data, t, this.options);
        return this.dispatch({
          data: s,
          type: "success",
          dataUpdatedAt: null == e ? void 0 : e.updatedAt,
          manual: null == e ? void 0 : e.manual
        }), s;
      }
    }, {
      key: "setState",
      value: function setState(t, e) {
        this.dispatch({
          type: "setState",
          state: t,
          setStateOptions: e
        });
      }
    }, {
      key: "cancel",
      value: function cancel(t) {
        var e;
        var s = this.promise;
        return null == (e = this.retryer) || e.cancel(t), s ? s.then(a).catch(a) : Promise.resolve();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        _get(_getPrototypeOf(j.prototype), "destroy", this).call(this), this.cancel({
          silent: !0
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        this.destroy(), this.setState(this.initialState);
      }
    }, {
      key: "isActive",
      value: function isActive() {
        return this.observers.some(function (t) {
          return !1 !== t.options.enabled;
        });
      }
    }, {
      key: "isDisabled",
      value: function isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
      }
    }, {
      key: "isStale",
      value: function isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (t) {
          return t.getCurrentResult().isStale;
        });
      }
    }, {
      key: "isStaleByTime",
      value: function isStaleByTime() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !h(this.state.dataUpdatedAt, t);
      }
    }, {
      key: "onFocus",
      value: function onFocus() {
        var t;
        var e = this.observers.find(function (t) {
          return t.shouldFetchOnWindowFocus();
        });
        e && e.refetch({
          cancelRefetch: !1
        }), null == (t = this.retryer) || t.continue();
      }
    }, {
      key: "onOnline",
      value: function onOnline() {
        var t;
        var e = this.observers.find(function (t) {
          return t.shouldFetchOnReconnect();
        });
        e && e.refetch({
          cancelRefetch: !1
        }), null == (t = this.retryer) || t.continue();
      }
    }, {
      key: "addObserver",
      value: function addObserver(t) {
        -1 === this.observers.indexOf(t) && (this.observers.push(t), this.clearGcTimeout(), this.cache.notify({
          type: "observerAdded",
          query: this,
          observer: t
        }));
      }
    }, {
      key: "removeObserver",
      value: function removeObserver(t) {
        -1 !== this.observers.indexOf(t) && (this.observers = this.observers.filter(function (e) {
          return e !== t;
        }), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
          revert: !0
        }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
          type: "observerRemoved",
          query: this,
          observer: t
        }));
      }
    }, {
      key: "getObserversCount",
      value: function getObserversCount() {
        return this.observers.length;
      }
    }, {
      key: "invalidate",
      value: function invalidate() {
        this.state.isInvalidated || this.dispatch({
          type: "invalidate"
        });
      }
    }, {
      key: "fetch",
      value: function fetch(t, e) {
        var _this8 = this;
        var s, r;
        if ("idle" !== this.state.fetchStatus) if (this.state.dataUpdatedAt && null != e && e.cancelRefetch) this.cancel({
          silent: !0
        });else if (this.promise) {
          var i;
          return null == (i = this.retryer) || i.continueRetry(), this.promise;
        }
        if (t && this.setOptions(t), !this.options.queryFn) {
          var _t2 = this.observers.find(function (t) {
            return t.options.queryFn;
          });
          _t2 && this.setOptions(_t2.options);
        }
        Array.isArray(this.options.queryKey);
        var n = function () {
            if ("function" == typeof AbortController) return new AbortController();
          }(),
          o = {
            queryKey: this.queryKey,
            pageParam: void 0,
            meta: this.meta
          },
          a = function a(t) {
            Object.defineProperty(t, "signal", {
              enumerable: !0,
              get: function get() {
                if (n) return _this8.abortSignalConsumed = !0, n.signal;
              }
            });
          };
        a(o);
        var u = {
          fetchOptions: e,
          options: this.options,
          queryKey: this.queryKey,
          state: this.state,
          fetchFn: function fetchFn() {
            return _this8.options.queryFn ? (_this8.abortSignalConsumed = !1, _this8.options.queryFn(o)) : Promise.reject("Missing queryFn");
          },
          meta: this.meta
        };
        var c;
        (a(u), null == (s = this.options.behavior) || s.onFetch(u), this.revertState = this.state, "idle" === this.state.fetchStatus || this.state.fetchMeta !== (null == (r = u.fetchOptions) ? void 0 : r.meta)) && this.dispatch({
          type: "fetch",
          meta: null == (c = u.fetchOptions) ? void 0 : c.meta
        });
        var h = function h(t) {
          var e, s;
          (I(t) && t.silent || _this8.dispatch({
            type: "error",
            error: t
          }), I(t)) || null == (e = (s = _this8.cache.config).onError) || e.call(s, t, _this8);
          _this8.isFetchingOptimistic || _this8.scheduleGc(), _this8.isFetchingOptimistic = !1;
        };
        return this.retryer = T({
          fn: u.fetchFn,
          abort: null == n ? void 0 : n.abort.bind(n),
          onSuccess: function onSuccess(t) {
            var e, s;
            void 0 !== t ? (_this8.setData(t), null == (e = (s = _this8.cache.config).onSuccess) || e.call(s, t, _this8), _this8.isFetchingOptimistic || _this8.scheduleGc(), _this8.isFetchingOptimistic = !1) : h(new Error("Query data cannot be undefined"));
          },
          onError: h,
          onFail: function onFail() {
            _this8.dispatch({
              type: "failed"
            });
          },
          onPause: function onPause() {
            _this8.dispatch({
              type: "pause"
            });
          },
          onContinue: function onContinue() {
            _this8.dispatch({
              type: "continue"
            });
          },
          retry: u.options.retry,
          retryDelay: u.options.retryDelay,
          networkMode: u.options.networkMode
        }), this.promise = this.retryer.promise, this.promise;
      }
    }, {
      key: "dispatch",
      value: function dispatch(t) {
        var _this9 = this;
        this.state = function (e) {
          var s, r;
          switch (t.type) {
            case "failed":
              return _objectSpread(_objectSpread({}, e), {}, {
                fetchFailureCount: e.fetchFailureCount + 1
              });
            case "pause":
              return _objectSpread(_objectSpread({}, e), {}, {
                fetchStatus: "paused"
              });
            case "continue":
              return _objectSpread(_objectSpread({}, e), {}, {
                fetchStatus: "fetching"
              });
            case "fetch":
              return _objectSpread(_objectSpread({}, e), {}, {
                fetchFailureCount: 0,
                fetchMeta: null != (s = t.meta) ? s : null,
                fetchStatus: D(_this9.options.networkMode) ? "fetching" : "paused"
              }, !e.dataUpdatedAt && {
                error: null,
                status: "loading"
              });
            case "success":
              return _objectSpread(_objectSpread({}, e), {}, {
                data: t.data,
                dataUpdateCount: e.dataUpdateCount + 1,
                dataUpdatedAt: null != (r = t.dataUpdatedAt) ? r : Date.now(),
                error: null,
                isInvalidated: !1,
                status: "success"
              }, !t.manual && {
                fetchStatus: "idle",
                fetchFailureCount: 0
              });
            case "error":
              var _i2 = t.error;
              return I(_i2) && _i2.revert && _this9.revertState ? _objectSpread({}, _this9.revertState) : _objectSpread(_objectSpread({}, e), {}, {
                error: _i2,
                errorUpdateCount: e.errorUpdateCount + 1,
                errorUpdatedAt: Date.now(),
                fetchFailureCount: e.fetchFailureCount + 1,
                fetchStatus: "idle",
                status: "error"
              });
            case "invalidate":
              return _objectSpread(_objectSpread({}, e), {}, {
                isInvalidated: !0
              });
            case "setState":
              return _objectSpread(_objectSpread({}, e), t.state);
          }
        }(this.state), k.batch(function () {
          _this9.observers.forEach(function (e) {
            e.onQueryUpdate(t);
          }), _this9.cache.notify({
            query: _this9,
            type: "updated",
            action: t
          });
        });
      }
    }]);
    return j;
  }(L);
  var H = /*#__PURE__*/function (_n5) {
    _inherits(H, _n5);
    var _super4 = _createSuper(H);
    function H(t) {
      var _this10;
      _classCallCheck(this, H);
      _this10 = _super4.call(this), _this10.config = t || {}, _this10.queries = [], _this10.queriesMap = {};
      return _this10;
    }
    _createClass(H, [{
      key: "build",
      value: function build(t, e, s) {
        var r;
        var i = e.queryKey,
          n = null != (r = e.queryHash) ? r : m(i, e);
        var o = this.get(n);
        return o || (o = new j({
          cache: this,
          logger: t.getLogger(),
          queryKey: i,
          queryHash: n,
          options: t.defaultQueryOptions(e),
          state: s,
          defaultOptions: t.getQueryDefaults(i),
          meta: e.meta
        }), this.add(o)), o;
      }
    }, {
      key: "add",
      value: function add(t) {
        this.queriesMap[t.queryHash] || (this.queriesMap[t.queryHash] = t, this.queries.push(t), this.notify({
          type: "added",
          query: t
        }));
      }
    }, {
      key: "remove",
      value: function remove(t) {
        var e = this.queriesMap[t.queryHash];
        e && (t.destroy(), this.queries = this.queries.filter(function (e) {
          return e !== t;
        }), e === t && delete this.queriesMap[t.queryHash], this.notify({
          type: "removed",
          query: t
        }));
      }
    }, {
      key: "clear",
      value: function clear() {
        var _this11 = this;
        k.batch(function () {
          _this11.queries.forEach(function (t) {
            _this11.remove(t);
          });
        });
      }
    }, {
      key: "get",
      value: function get(t) {
        return this.queriesMap[t];
      }
    }, {
      key: "getAll",
      value: function getAll() {
        return this.queries;
      }
    }, {
      key: "find",
      value: function find(t, e) {
        var _f = f(t, e),
          _f2 = _slicedToArray(_f, 1),
          s = _f2[0];
        return void 0 === s.exact && (s.exact = !0), this.queries.find(function (t) {
          return y(s, t);
        });
      }
    }, {
      key: "findAll",
      value: function findAll(t, e) {
        var _f3 = f(t, e),
          _f4 = _slicedToArray(_f3, 1),
          s = _f4[0];
        return Object.keys(s).length > 0 ? this.queries.filter(function (t) {
          return y(s, t);
        }) : this.queries;
      }
    }, {
      key: "notify",
      value: function notify(t) {
        var _this12 = this;
        k.batch(function () {
          _this12.listeners.forEach(function (e) {
            e(t);
          });
        });
      }
    }, {
      key: "onFocus",
      value: function onFocus() {
        var _this13 = this;
        k.batch(function () {
          _this13.queries.forEach(function (t) {
            t.onFocus();
          });
        });
      }
    }, {
      key: "onOnline",
      value: function onOnline() {
        var _this14 = this;
        k.batch(function () {
          _this14.queries.forEach(function (t) {
            t.onOnline();
          });
        });
      }
    }]);
    return H;
  }(n);
  var N = /*#__PURE__*/function (_L2) {
    _inherits(N, _L2);
    var _super5 = _createSuper(N);
    function N(t) {
      var _this15;
      _classCallCheck(this, N);
      _this15 = _super5.call(this), _this15.options = _objectSpread(_objectSpread({}, t.defaultOptions), t.options), _this15.mutationId = t.mutationId, _this15.mutationCache = t.mutationCache, _this15.logger = t.logger || K, _this15.observers = [], _this15.state = t.state || B(), _this15.meta = t.meta, _this15.updateCacheTime(_this15.options.cacheTime), _this15.scheduleGc();
      return _this15;
    }
    _createClass(N, [{
      key: "setState",
      value: function setState(t) {
        this.dispatch({
          type: "setState",
          state: t
        });
      }
    }, {
      key: "addObserver",
      value: function addObserver(t) {
        -1 === this.observers.indexOf(t) && (this.observers.push(t), this.clearGcTimeout(), this.mutationCache.notify({
          type: "observerAdded",
          mutation: this,
          observer: t
        }));
      }
    }, {
      key: "removeObserver",
      value: function removeObserver(t) {
        this.observers = this.observers.filter(function (e) {
          return e !== t;
        }), this.scheduleGc(), this.mutationCache.notify({
          type: "observerRemoved",
          mutation: this,
          observer: t
        });
      }
    }, {
      key: "optionalRemove",
      value: function optionalRemove() {
        this.observers.length || ("loading" === this.state.status ? this.scheduleGc() : this.mutationCache.remove(this));
      }
    }, {
      key: "continue",
      value: function _continue() {
        return this.retryer ? (this.retryer.continue(), this.retryer.promise) : this.execute();
      }
    }, {
      key: "execute",
      value: function () {
        var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this16 = this;
          var t, e, s, r, i, n, o, a, u, c, h, l, _t3, _d, d, f, p, y, v, m;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  t = function t() {
                    var t;
                    return _this16.retryer = T({
                      fn: function fn() {
                        return _this16.options.mutationFn ? _this16.options.mutationFn(_this16.state.variables) : Promise.reject("No mutationFn found");
                      },
                      onFail: function onFail() {
                        _this16.dispatch({
                          type: "failed"
                        });
                      },
                      onPause: function onPause() {
                        _this16.dispatch({
                          type: "pause"
                        });
                      },
                      onContinue: function onContinue() {
                        _this16.dispatch({
                          type: "continue"
                        });
                      },
                      retry: null != (t = _this16.options.retry) ? t : 0,
                      retryDelay: _this16.options.retryDelay,
                      networkMode: _this16.options.networkMode
                    }), _this16.retryer.promise;
                  }, e = "loading" === this.state.status;
                  _context.prev = 1;
                  if (e) {
                    _context.next = 8;
                    break;
                  }
                  this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                  }), null == (u = (c = this.mutationCache.config).onMutate) || u.call(c, this.state.variables, this);
                  _context.next = 6;
                  return null == (h = (l = this.options).onMutate) ? void 0 : h.call(l, this.state.variables);
                case 6:
                  _t3 = _context.sent;
                  _t3 !== this.state.context && this.dispatch({
                    type: "loading",
                    context: _t3,
                    variables: this.state.variables
                  });
                case 8:
                  _context.next = 10;
                  return t();
                case 10:
                  _d = _context.sent;
                  null == (s = (r = this.mutationCache.config).onSuccess) || s.call(r, _d, this.state.variables, this.state.context, this);
                  _context.next = 14;
                  return null == (i = (n = this.options).onSuccess) ? void 0 : i.call(n, _d, this.state.variables, this.state.context);
                case 14:
                  _context.next = 16;
                  return null == (o = (a = this.options).onSettled) ? void 0 : o.call(a, _d, null, this.state.variables, this.state.context);
                case 16:
                  this.dispatch({
                    type: "success",
                    data: _d
                  });
                  return _context.abrupt("return", _d);
                case 20:
                  _context.prev = 20;
                  _context.t0 = _context["catch"](1);
                  _context.prev = 22;
                  null == (d = (f = this.mutationCache.config).onError) || d.call(f, _context.t0, this.state.variables, this.state.context, this);
                  _context.next = 26;
                  return null == (p = (y = this.options).onError) ? void 0 : p.call(y, _context.t0, this.state.variables, this.state.context);
                case 26:
                  _context.next = 28;
                  return null == (v = (m = this.options).onSettled) ? void 0 : v.call(m, void 0, _context.t0, this.state.variables, this.state.context);
                case 28:
                  throw _context.t0;
                case 29:
                  _context.prev = 29;
                  this.dispatch({
                    type: "error",
                    error: _context.t0
                  });
                  return _context.finish(29);
                case 32:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[1, 20], [22,, 29, 32]]);
        }));
        function execute() {
          return _execute.apply(this, arguments);
        }
        return execute;
      }()
    }, {
      key: "dispatch",
      value: function dispatch(t) {
        var _this17 = this;
        this.state = function (e) {
          switch (t.type) {
            case "failed":
              return _objectSpread(_objectSpread({}, e), {}, {
                failureCount: e.failureCount + 1
              });
            case "pause":
              return _objectSpread(_objectSpread({}, e), {}, {
                isPaused: !0
              });
            case "continue":
              return _objectSpread(_objectSpread({}, e), {}, {
                isPaused: !1
              });
            case "loading":
              return _objectSpread(_objectSpread({}, e), {}, {
                context: t.context,
                data: void 0,
                error: null,
                isPaused: !D(_this17.options.networkMode),
                status: "loading",
                variables: t.variables
              });
            case "success":
              return _objectSpread(_objectSpread({}, e), {}, {
                data: t.data,
                error: null,
                status: "success",
                isPaused: !1
              });
            case "error":
              return _objectSpread(_objectSpread({}, e), {}, {
                data: void 0,
                error: t.error,
                failureCount: e.failureCount + 1,
                isPaused: !1,
                status: "error"
              });
            case "setState":
              return _objectSpread(_objectSpread({}, e), t.state);
          }
        }(this.state), k.batch(function () {
          _this17.observers.forEach(function (e) {
            e.onMutationUpdate(t);
          }), _this17.mutationCache.notify({
            mutation: _this17,
            type: "updated",
            action: t
          });
        });
      }
    }]);
    return N;
  }(L);
  function B() {
    return {
      context: void 0,
      data: void 0,
      error: null,
      failureCount: 0,
      isPaused: !1,
      status: "idle",
      variables: void 0
    };
  }
  var G = /*#__PURE__*/function (_n6) {
    _inherits(G, _n6);
    var _super6 = _createSuper(G);
    function G(t) {
      var _this18;
      _classCallCheck(this, G);
      _this18 = _super6.call(this), _this18.config = t || {}, _this18.mutations = [], _this18.mutationId = 0;
      return _this18;
    }
    _createClass(G, [{
      key: "build",
      value: function build(t, e, s) {
        var r = new N({
          mutationCache: this,
          logger: t.getLogger(),
          mutationId: ++this.mutationId,
          options: t.defaultMutationOptions(e),
          state: s,
          defaultOptions: e.mutationKey ? t.getMutationDefaults(e.mutationKey) : void 0,
          meta: e.meta
        });
        return this.add(r), r;
      }
    }, {
      key: "add",
      value: function add(t) {
        this.mutations.push(t), this.notify({
          type: "added",
          mutation: t
        });
      }
    }, {
      key: "remove",
      value: function remove(t) {
        this.mutations = this.mutations.filter(function (e) {
          return e !== t;
        }), this.notify({
          type: "removed",
          mutation: t
        });
      }
    }, {
      key: "clear",
      value: function clear() {
        var _this19 = this;
        k.batch(function () {
          _this19.mutations.forEach(function (t) {
            _this19.remove(t);
          });
        });
      }
    }, {
      key: "getAll",
      value: function getAll() {
        return this.mutations;
      }
    }, {
      key: "find",
      value: function find(t) {
        return void 0 === t.exact && (t.exact = !0), this.mutations.find(function (e) {
          return v(t, e);
        });
      }
    }, {
      key: "findAll",
      value: function findAll(t) {
        return this.mutations.filter(function (e) {
          return v(t, e);
        });
      }
    }, {
      key: "notify",
      value: function notify(t) {
        var _this20 = this;
        k.batch(function () {
          _this20.listeners.forEach(function (e) {
            e(t);
          });
        });
      }
    }, {
      key: "resumePausedMutations",
      value: function resumePausedMutations() {
        var t = this.mutations.filter(function (t) {
          return t.state.isPaused;
        });
        return k.batch(function () {
          return t.reduce(function (t, e) {
            return t.then(function () {
              return e.continue().catch(a);
            });
          }, Promise.resolve());
        });
      }
    }]);
    return G;
  }(n);
  function _() {
    return {
      onFetch: function onFetch(t) {
        t.fetchFn = function () {
          var e, s, r, i, n, o;
          var a = null == (e = t.fetchOptions) || null == (s = e.meta) ? void 0 : s.refetchPage,
            u = null == (r = t.fetchOptions) || null == (i = r.meta) ? void 0 : i.fetchMore,
            c = null == u ? void 0 : u.pageParam,
            h = "forward" === (null == u ? void 0 : u.direction),
            l = "backward" === (null == u ? void 0 : u.direction),
            d = (null == (n = t.state.data) ? void 0 : n.pages) || [],
            f = (null == (o = t.state.data) ? void 0 : o.pageParams) || [];
          var p = f,
            y = !1;
          var v = t.options.queryFn || function () {
              return Promise.reject("Missing queryFn");
            },
            m = function m(t, e, s, r) {
              return p = r ? [e].concat(_toConsumableArray(p)) : [].concat(_toConsumableArray(p), [e]), r ? [s].concat(_toConsumableArray(t)) : [].concat(_toConsumableArray(t), [s]);
            },
            b = function b(e, s, r, i) {
              if (y) return Promise.reject("Cancelled");
              if (void 0 === r && !s && e.length) return Promise.resolve(e);
              var n = {
                queryKey: t.queryKey,
                pageParam: r,
                meta: t.meta
              };
              var o;
              o = n, Object.defineProperty(o, "signal", {
                enumerable: !0,
                get: function get() {
                  var e, s;
                  return null != (e = t.signal) && e.aborted ? y = !0 : null == (s = t.signal) || s.addEventListener("abort", function () {
                    y = !0;
                  }), t.signal;
                }
              });
              var a = v(n);
              return Promise.resolve(a).then(function (t) {
                return m(e, r, t, i);
              });
            };
          var g;
          if (d.length) {
            if (h) {
              var _e3 = void 0 !== c,
                _s2 = _e3 ? c : W(t.options, d);
              g = b(d, _e3, _s2);
            } else if (l) {
              var _e4 = void 0 !== c,
                _s3 = _e4 ? c : z(t.options, d);
              g = b(d, _e4, _s3, !0);
            } else {
              (function () {
                p = [];
                var e = void 0 === t.options.getNextPageParam;
                g = !a || !d[0] || a(d[0], 0, d) ? b([], e, f[0]) : Promise.resolve(m([], f[0], d[0]));
                var _loop = function _loop(_s4) {
                  g = g.then(function (r) {
                    if (!a || !d[_s4] || a(d[_s4], _s4, d)) {
                      var _i3 = e ? f[_s4] : W(t.options, r);
                      return b(r, e, _i3);
                    }
                    return Promise.resolve(m(r, f[_s4], d[_s4]));
                  });
                };
                for (var _s4 = 1; _s4 < d.length; _s4++) {
                  _loop(_s4);
                }
              })();
            }
          } else g = b([]);
          return g.then(function (t) {
            return {
              pages: t,
              pageParams: p
            };
          });
        };
      }
    };
  }
  function W(t, e) {
    return null == t.getNextPageParam ? void 0 : t.getNextPageParam(e[e.length - 1], e);
  }
  function z(t, e) {
    return null == t.getPreviousPageParam ? void 0 : t.getPreviousPageParam(e[0], e);
  }
  function J(t, e) {
    if (t.getNextPageParam && Array.isArray(e)) {
      var s = W(t, e);
      return null != s && !1 !== s;
    }
  }
  function V(t, e) {
    if (t.getPreviousPageParam && Array.isArray(e)) {
      var s = z(t, e);
      return null != s && !1 !== s;
    }
  }
  var X = /*#__PURE__*/function (_n7) {
    _inherits(X, _n7);
    var _super7 = _createSuper(X);
    function X(t, e) {
      var _this21;
      _classCallCheck(this, X);
      _this21 = _super7.call(this), _this21.client = t, _this21.options = e, _this21.trackedProps = new Set(), _this21.selectError = null, _this21.bindMethods(), _this21.setOptions(e);
      return _this21;
    }
    _createClass(X, [{
      key: "bindMethods",
      value: function bindMethods() {
        this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
      }
    }, {
      key: "onSubscribe",
      value: function onSubscribe() {
        1 === this.listeners.length && (this.currentQuery.addObserver(this), Y(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
      }
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {
        this.listeners.length || this.destroy();
      }
    }, {
      key: "shouldFetchOnReconnect",
      value: function shouldFetchOnReconnect() {
        return Z(this.currentQuery, this.options, this.options.refetchOnReconnect);
      }
    }, {
      key: "shouldFetchOnWindowFocus",
      value: function shouldFetchOnWindowFocus() {
        return Z(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.listeners = [], this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
      }
    }, {
      key: "setOptions",
      value: function setOptions(t, e) {
        var s = this.options,
          r = this.currentQuery;
        if (this.options = this.client.defaultQueryOptions(t), R(s, this.options) || this.client.getQueryCache().notify({
          type: "observerOptionsUpdated",
          query: this.currentQuery,
          observer: this
        }), void 0 !== this.options.enabled && "boolean" != typeof this.options.enabled) throw new Error("Expected enabled to be a boolean");
        this.options.queryKey || (this.options.queryKey = s.queryKey), this.updateQuery();
        var i = this.hasListeners();
        i && $(this.currentQuery, r, this.options, s) && this.executeFetch(), this.updateResult(e), !i || this.currentQuery === r && this.options.enabled === s.enabled && this.options.staleTime === s.staleTime || this.updateStaleTimeout();
        var n = this.computeRefetchInterval();
        !i || this.currentQuery === r && this.options.enabled === s.enabled && n === this.currentRefetchInterval || this.updateRefetchInterval(n);
      }
    }, {
      key: "getOptimisticResult",
      value: function getOptimisticResult(t) {
        var e = this.client.getQueryCache().build(this.client, t);
        return this.createResult(e, t);
      }
    }, {
      key: "getCurrentResult",
      value: function getCurrentResult() {
        return this.currentResult;
      }
    }, {
      key: "trackResult",
      value: function trackResult(t) {
        var _this22 = this;
        var e = {};
        return Object.keys(t).forEach(function (s) {
          Object.defineProperty(e, s, {
            configurable: !1,
            enumerable: !0,
            get: function get() {
              return _this22.trackedProps.add(s), t[s];
            }
          });
        }), e;
      }
    }, {
      key: "getCurrentQuery",
      value: function getCurrentQuery() {
        return this.currentQuery;
      }
    }, {
      key: "remove",
      value: function remove() {
        this.client.getQueryCache().remove(this.currentQuery);
      }
    }, {
      key: "refetch",
      value: function refetch() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = _ref.refetchPage,
          e = _objectWithoutProperties(_ref, _excluded);
        return this.fetch(_objectSpread(_objectSpread({}, e), {}, {
          meta: {
            refetchPage: t
          }
        }));
      }
    }, {
      key: "fetchOptimistic",
      value: function fetchOptimistic(t) {
        var _this23 = this;
        var e = this.client.defaultQueryOptions(t),
          s = this.client.getQueryCache().build(this.client, e);
        return s.isFetchingOptimistic = !0, s.fetch().then(function () {
          return _this23.createResult(s, e);
        });
      }
    }, {
      key: "fetch",
      value: function fetch(t) {
        var _this24 = this;
        var e;
        return this.executeFetch(_objectSpread(_objectSpread({}, t), {}, {
          cancelRefetch: null == (e = t.cancelRefetch) || e
        })).then(function () {
          return _this24.updateResult(), _this24.currentResult;
        });
      }
    }, {
      key: "executeFetch",
      value: function executeFetch(t) {
        this.updateQuery();
        var e = this.currentQuery.fetch(this.options, t);
        return null != t && t.throwOnError || (e = e.catch(a)), e;
      }
    }, {
      key: "updateStaleTimeout",
      value: function updateStaleTimeout() {
        var _this25 = this;
        if (this.clearStaleTimeout(), o || this.currentResult.isStale || !u(this.options.staleTime)) return;
        var t = h(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
        this.staleTimeoutId = setTimeout(function () {
          _this25.currentResult.isStale || _this25.updateResult();
        }, t);
      }
    }, {
      key: "computeRefetchInterval",
      value: function computeRefetchInterval() {
        var t;
        return "function" == typeof this.options.refetchInterval ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : null != (t = this.options.refetchInterval) && t;
      }
    }, {
      key: "updateRefetchInterval",
      value: function updateRefetchInterval(t) {
        var _this26 = this;
        this.clearRefetchInterval(), this.currentRefetchInterval = t, !o && !1 !== this.options.enabled && u(this.currentRefetchInterval) && 0 !== this.currentRefetchInterval && (this.refetchIntervalId = setInterval(function () {
          (_this26.options.refetchIntervalInBackground || w.isFocused()) && _this26.executeFetch();
        }, this.currentRefetchInterval));
      }
    }, {
      key: "updateTimers",
      value: function updateTimers() {
        this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
      }
    }, {
      key: "clearStaleTimeout",
      value: function clearStaleTimeout() {
        this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
      }
    }, {
      key: "clearRefetchInterval",
      value: function clearRefetchInterval() {
        this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
      }
    }, {
      key: "createResult",
      value: function createResult(t, e) {
        var s = this.currentQuery,
          r = this.options,
          i = this.currentResult,
          n = this.currentResultState,
          o = this.currentResultOptions,
          a = t !== s,
          u = a ? t.state : this.currentQueryInitialState,
          c = a ? this.currentResult : this.previousQueryResult,
          h = t.state;
        var l,
          d = h.dataUpdatedAt,
          f = h.error,
          p = h.errorUpdatedAt,
          y = h.fetchStatus,
          v = h.status,
          m = !1,
          b = !1;
        if (e._optimisticResults) {
          var _i4 = this.hasListeners(),
            _n8 = !_i4 && Y(t, e),
            _o2 = _i4 && $(t, s, e, r);
          (_n8 || _o2) && (y = D(t.options.networkMode) ? "fetching" : "paused", d || (v = "loading")), "isRestoring" === e._optimisticResults && (y = "idle");
        }
        if (e.keepPreviousData && !h.dataUpdateCount && null != c && c.isSuccess && "error" !== v) l = c.data, d = c.dataUpdatedAt, v = c.status, m = !0;else if (e.select && void 0 !== h.data) {
          if (i && h.data === (null == n ? void 0 : n.data) && e.select === this.selectFn) l = this.selectResult;else try {
            this.selectFn = e.select, l = e.select(h.data), l = M(null == i ? void 0 : i.data, l, e), this.selectResult = l, this.selectError = null;
          } catch (t) {
            this.selectError = t;
          }
        } else l = h.data;
        if (void 0 !== e.placeholderData && void 0 === l && "loading" === v) {
          var _t4;
          if (null != i && i.isPlaceholderData && e.placeholderData === (null == o ? void 0 : o.placeholderData)) _t4 = i.data;else if (_t4 = "function" == typeof e.placeholderData ? e.placeholderData() : e.placeholderData, e.select && void 0 !== _t4) try {
            _t4 = e.select(_t4), _t4 = M(null == i ? void 0 : i.data, _t4, e), this.selectError = null;
          } catch (t) {
            this.selectError = t;
          }
          void 0 !== _t4 && (v = "success", l = _t4, b = !0);
        }
        this.selectError && (f = this.selectError, l = this.selectResult, p = Date.now(), v = "error");
        var g = "fetching" === y;
        return {
          status: v,
          fetchStatus: y,
          isLoading: "loading" === v,
          isSuccess: "success" === v,
          isError: "error" === v,
          data: l,
          dataUpdatedAt: d,
          error: f,
          errorUpdatedAt: p,
          failureCount: h.fetchFailureCount,
          errorUpdateCount: h.errorUpdateCount,
          isFetched: h.dataUpdateCount > 0 || h.errorUpdateCount > 0,
          isFetchedAfterMount: h.dataUpdateCount > u.dataUpdateCount || h.errorUpdateCount > u.errorUpdateCount,
          isFetching: g,
          isRefetching: g && "loading" !== v,
          isLoadingError: "error" === v && 0 === h.dataUpdatedAt,
          isPaused: "paused" === y,
          isPlaceholderData: b,
          isPreviousData: m,
          isRefetchError: "error" === v && 0 !== h.dataUpdatedAt,
          isStale: tt(t, e),
          refetch: this.refetch,
          remove: this.remove
        };
      }
    }, {
      key: "updateResult",
      value: function updateResult(t) {
        var _this27 = this;
        var e = this.currentResult,
          s = this.createResult(this.currentQuery, this.options);
        if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, R(s, e)) return;
        this.currentResult = s;
        var r = {
          cache: !0
        };
        !1 !== (null == t ? void 0 : t.listeners) && function () {
          if (!e) return !0;
          var t = _this27.options.notifyOnChangeProps;
          if ("all" === t || !t && !_this27.trackedProps.size) return !0;
          var s = new Set(null != t ? t : _this27.trackedProps);
          return _this27.options.useErrorBoundary && s.add("error"), Object.keys(_this27.currentResult).some(function (t) {
            var r = t;
            return _this27.currentResult[r] !== e[r] && s.has(r);
          });
        }() && (r.listeners = !0), this.notify(_objectSpread(_objectSpread({}, r), t));
      }
    }, {
      key: "updateQuery",
      value: function updateQuery() {
        var t = this.client.getQueryCache().build(this.client, this.options);
        if (t === this.currentQuery) return;
        var e = this.currentQuery;
        this.currentQuery = t, this.currentQueryInitialState = t.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (null == e || e.removeObserver(this), t.addObserver(this));
      }
    }, {
      key: "onQueryUpdate",
      value: function onQueryUpdate(t) {
        var e = {};
        "success" === t.type ? e.onSuccess = !t.manual : "error" !== t.type || I(t.error) || (e.onError = !0), this.updateResult(e), this.hasListeners() && this.updateTimers();
      }
    }, {
      key: "notify",
      value: function notify(t) {
        var _this28 = this;
        k.batch(function () {
          var e, s, r, i;
          if (t.onSuccess) null == (e = (s = _this28.options).onSuccess) || e.call(s, _this28.currentResult.data), null == (r = (i = _this28.options).onSettled) || r.call(i, _this28.currentResult.data, null);else if (t.onError) {
            var n, o, a, u;
            null == (n = (o = _this28.options).onError) || n.call(o, _this28.currentResult.error), null == (a = (u = _this28.options).onSettled) || a.call(u, void 0, _this28.currentResult.error);
          }
          t.listeners && _this28.listeners.forEach(function (t) {
            t(_this28.currentResult);
          }), t.cache && _this28.client.getQueryCache().notify({
            query: _this28.currentQuery,
            type: "observerResultsUpdated"
          });
        });
      }
    }]);
    return X;
  }(n);
  function Y(t, e) {
    return function (t, e) {
      return !(!1 === e.enabled || t.state.dataUpdatedAt || "error" === t.state.status && !1 === e.retryOnMount);
    }(t, e) || t.state.dataUpdatedAt > 0 && Z(t, e, e.refetchOnMount);
  }
  function Z(t, e, s) {
    if (!1 !== e.enabled) {
      var r = "function" == typeof s ? s(t) : s;
      return "always" === r || !1 !== r && tt(t, e);
    }
    return !1;
  }
  function $(t, e, s, r) {
    return !1 !== s.enabled && (t !== e || !1 === r.enabled) && (!s.suspense || "error" !== t.state.status) && tt(t, s);
  }
  function tt(t, e) {
    return t.isStaleByTime(e.staleTime);
  }
  var et = /*#__PURE__*/function (_n9) {
    _inherits(et, _n9);
    var _super8 = _createSuper(et);
    function et(t, e) {
      var _this29;
      _classCallCheck(this, et);
      _this29 = _super8.call(this), _this29.client = t, _this29.queries = [], _this29.result = [], _this29.observers = [], _this29.observersMap = {}, e && _this29.setQueries(e);
      return _this29;
    }
    _createClass(et, [{
      key: "onSubscribe",
      value: function onSubscribe() {
        var _this30 = this;
        1 === this.listeners.length && this.observers.forEach(function (t) {
          t.subscribe(function (e) {
            _this30.onUpdate(t, e);
          });
        });
      }
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {
        this.listeners.length || this.destroy();
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.listeners = [], this.observers.forEach(function (t) {
          t.destroy();
        });
      }
    }, {
      key: "setQueries",
      value: function setQueries(t, e) {
        var _this31 = this;
        this.queries = t, k.batch(function () {
          var t = _this31.observers,
            s = _this31.findMatchingObservers(_this31.queries);
          s.forEach(function (t) {
            return t.observer.setOptions(t.defaultedQueryOptions, e);
          });
          var r = s.map(function (t) {
              return t.observer;
            }),
            i = Object.fromEntries(r.map(function (t) {
              return [t.options.queryHash, t];
            })),
            n = r.map(function (t) {
              return t.getCurrentResult();
            }),
            o = r.some(function (e, s) {
              return e !== t[s];
            });
          (t.length !== r.length || o) && (_this31.observers = r, _this31.observersMap = i, _this31.result = n, _this31.hasListeners() && (c(t, r).forEach(function (t) {
            t.destroy();
          }), c(r, t).forEach(function (t) {
            t.subscribe(function (e) {
              _this31.onUpdate(t, e);
            });
          }), _this31.notify()));
        });
      }
    }, {
      key: "getCurrentResult",
      value: function getCurrentResult() {
        return this.result;
      }
    }, {
      key: "getOptimisticResult",
      value: function getOptimisticResult(t) {
        return this.findMatchingObservers(t).map(function (t) {
          return t.observer.getOptimisticResult(t.defaultedQueryOptions);
        });
      }
    }, {
      key: "findMatchingObservers",
      value: function findMatchingObservers(t) {
        var _this32 = this;
        var e = this.observers,
          s = t.map(function (t) {
            return _this32.client.defaultQueryOptions(t);
          }),
          r = s.flatMap(function (t) {
            var s = e.find(function (e) {
              return e.options.queryHash === t.queryHash;
            });
            return null != s ? [{
              defaultedQueryOptions: t,
              observer: s
            }] : [];
          }),
          i = r.map(function (t) {
            return t.defaultedQueryOptions.queryHash;
          }),
          n = s.filter(function (t) {
            return !i.includes(t.queryHash);
          }),
          o = e.filter(function (t) {
            return !r.some(function (e) {
              return e.observer === t;
            });
          }),
          a = function a(t) {
            var e = _this32.client.defaultQueryOptions(t),
              s = _this32.observersMap[e.queryHash];
            return null != s ? s : new X(_this32.client, e);
          },
          u = n.map(function (t, e) {
            if (t.keepPreviousData) {
              var _s5 = o[e];
              if (void 0 !== _s5) return {
                defaultedQueryOptions: t,
                observer: _s5
              };
            }
            return {
              defaultedQueryOptions: t,
              observer: a(t)
            };
          });
        return r.concat(u).sort(function (t, e) {
          return s.indexOf(t.defaultedQueryOptions) - s.indexOf(e.defaultedQueryOptions);
        });
      }
    }, {
      key: "onUpdate",
      value: function onUpdate(t, e) {
        var s = this.observers.indexOf(t);
        -1 !== s && (this.result = function (t, e, s) {
          var r = t.slice(0);
          return r[e] = s, r;
        }(this.result, s, e), this.notify());
      }
    }, {
      key: "notify",
      value: function notify() {
        var _this33 = this;
        k.batch(function () {
          _this33.listeners.forEach(function (t) {
            t(_this33.result);
          });
        });
      }
    }]);
    return et;
  }(n);
  var st = /*#__PURE__*/function (_X) {
    _inherits(st, _X);
    var _super9 = _createSuper(st);
    function st(t, e) {
      _classCallCheck(this, st);
      return _super9.call(this, t, e);
    }
    _createClass(st, [{
      key: "bindMethods",
      value: function bindMethods() {
        _get(_getPrototypeOf(st.prototype), "bindMethods", this).call(this), this.fetchNextPage = this.fetchNextPage.bind(this), this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
      }
    }, {
      key: "setOptions",
      value: function setOptions(t, e) {
        _get(_getPrototypeOf(st.prototype), "setOptions", this).call(this, _objectSpread(_objectSpread({}, t), {}, {
          behavior: _()
        }), e);
      }
    }, {
      key: "getOptimisticResult",
      value: function getOptimisticResult(t) {
        return t.behavior = _(), _get(_getPrototypeOf(st.prototype), "getOptimisticResult", this).call(this, t);
      }
    }, {
      key: "fetchNextPage",
      value: function fetchNextPage() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = _ref2.pageParam,
          e = _objectWithoutProperties(_ref2, _excluded2);
        return this.fetch(_objectSpread(_objectSpread({}, e), {}, {
          meta: {
            fetchMore: {
              direction: "forward",
              pageParam: t
            }
          }
        }));
      }
    }, {
      key: "fetchPreviousPage",
      value: function fetchPreviousPage() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          t = _ref3.pageParam,
          e = _objectWithoutProperties(_ref3, _excluded3);
        return this.fetch(_objectSpread(_objectSpread({}, e), {}, {
          meta: {
            fetchMore: {
              direction: "backward",
              pageParam: t
            }
          }
        }));
      }
    }, {
      key: "createResult",
      value: function createResult(t, e) {
        var s, r, i, n, o, a;
        var u = t.state;
        return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(st.prototype), "createResult", this).call(this, t, e)), {}, {
          fetchNextPage: this.fetchNextPage,
          fetchPreviousPage: this.fetchPreviousPage,
          hasNextPage: J(e, null == (s = u.data) ? void 0 : s.pages),
          hasPreviousPage: V(e, null == (r = u.data) ? void 0 : r.pages),
          isFetchingNextPage: "fetching" === u.fetchStatus && "forward" === (null == (i = u.fetchMeta) || null == (n = i.fetchMore) ? void 0 : n.direction),
          isFetchingPreviousPage: "fetching" === u.fetchStatus && "backward" === (null == (o = u.fetchMeta) || null == (a = o.fetchMore) ? void 0 : a.direction)
        });
      }
    }]);
    return st;
  }(X);
  var rt = /*#__PURE__*/function (_n10) {
    _inherits(rt, _n10);
    var _super10 = _createSuper(rt);
    function rt(t, e) {
      var _this34;
      _classCallCheck(this, rt);
      _this34 = _super10.call(this), _this34.client = t, _this34.setOptions(e), _this34.bindMethods(), _this34.updateResult();
      return _this34;
    }
    _createClass(rt, [{
      key: "bindMethods",
      value: function bindMethods() {
        this.mutate = this.mutate.bind(this), this.reset = this.reset.bind(this);
      }
    }, {
      key: "setOptions",
      value: function setOptions(t) {
        var e = this.options;
        this.options = this.client.defaultMutationOptions(t), R(e, this.options) || this.client.getMutationCache().notify({
          type: "observerOptionsUpdated",
          mutation: this.currentMutation,
          observer: this
        });
      }
    }, {
      key: "onUnsubscribe",
      value: function onUnsubscribe() {
        var t;
        this.listeners.length || null == (t = this.currentMutation) || t.removeObserver(this);
      }
    }, {
      key: "onMutationUpdate",
      value: function onMutationUpdate(t) {
        this.updateResult();
        var e = {
          listeners: !0
        };
        "success" === t.type ? e.onSuccess = !0 : "error" === t.type && (e.onError = !0), this.notify(e);
      }
    }, {
      key: "getCurrentResult",
      value: function getCurrentResult() {
        return this.currentResult;
      }
    }, {
      key: "reset",
      value: function reset() {
        this.currentMutation = void 0, this.updateResult(), this.notify({
          listeners: !0
        });
      }
    }, {
      key: "mutate",
      value: function mutate(t, e) {
        return this.mutateOptions = e, this.currentMutation && this.currentMutation.removeObserver(this), this.currentMutation = this.client.getMutationCache().build(this.client, _objectSpread(_objectSpread({}, this.options), {}, {
          variables: void 0 !== t ? t : this.options.variables
        })), this.currentMutation.addObserver(this), this.currentMutation.execute();
      }
    }, {
      key: "updateResult",
      value: function updateResult() {
        var t = this.currentMutation ? this.currentMutation.state : {
            context: void 0,
            data: void 0,
            error: null,
            failureCount: 0,
            isPaused: !1,
            status: "idle",
            variables: void 0
          },
          e = _objectSpread(_objectSpread({}, t), {}, {
            isLoading: "loading" === t.status,
            isSuccess: "success" === t.status,
            isError: "error" === t.status,
            isIdle: "idle" === t.status,
            mutate: this.mutate,
            reset: this.reset
          });
        this.currentResult = e;
      }
    }, {
      key: "notify",
      value: function notify(t) {
        var _this35 = this;
        k.batch(function () {
          var e, s, r, i;
          if (_this35.mutateOptions) if (t.onSuccess) null == (e = (s = _this35.mutateOptions).onSuccess) || e.call(s, _this35.currentResult.data, _this35.currentResult.variables, _this35.currentResult.context), null == (r = (i = _this35.mutateOptions).onSettled) || r.call(i, _this35.currentResult.data, null, _this35.currentResult.variables, _this35.currentResult.context);else if (t.onError) {
            var n, o, a, u;
            null == (n = (o = _this35.mutateOptions).onError) || n.call(o, _this35.currentResult.error, _this35.currentResult.variables, _this35.currentResult.context), null == (a = (u = _this35.mutateOptions).onSettled) || a.call(u, void 0, _this35.currentResult.error, _this35.currentResult.variables, _this35.currentResult.context);
          }
          t.listeners && _this35.listeners.forEach(function (t) {
            t(_this35.currentResult);
          });
        });
      }
    }]);
    return rt;
  }(n);
  function it(t) {
    return t.state.isPaused;
  }
  function nt(t) {
    return "success" === t.state.status;
  }
  function ot(t, e, s) {
    if ("object" != typeof e || null === e) return;
    var r = t.getMutationCache(),
      i = t.getQueryCache(),
      n = e.mutations || [],
      o = e.queries || [];
    n.forEach(function (e) {
      var i;
      r.build(t, _objectSpread(_objectSpread({}, null == s || null == (i = s.defaultOptions) ? void 0 : i.mutations), {}, {
        mutationKey: e.mutationKey
      }), e.state);
    }), o.forEach(function (e) {
      var r;
      var n = i.get(e.queryHash);
      n ? n.state.dataUpdatedAt < e.state.dataUpdatedAt && n.setState(e.state) : i.build(t, _objectSpread(_objectSpread({}, null == s || null == (r = s.defaultOptions) ? void 0 : r.queries), {}, {
        queryKey: e.queryKey,
        queryHash: e.queryHash
      }), e.state);
    });
  }
  var at = i.createContext(void 0),
    ut = i.createContext(!1);
  function ct(t, e) {
    return t || (e && "undefined" != typeof window ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = at), window.ReactQueryClientContext) : at);
  }
  var ht = function ht() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        t = _ref4.context;
      var e = i.useContext(ct(t, i.useContext(ut)));
      if (!e) throw new Error("No QueryClient set, use QueryClientProvider to set one");
      return e;
    },
    lt = i.createContext(!1),
    dt = function dt() {
      return i.useContext(lt);
    },
    ft = lt.Provider;
  function pt() {
    var t = !1;
    return {
      clearReset: function clearReset() {
        t = !1;
      },
      reset: function reset() {
        t = !0;
      },
      isReset: function isReset() {
        return t;
      }
    };
  }
  var yt = i.createContext(pt()),
    vt = function vt() {
      return i.useContext(yt);
    };
  function mt(t, e) {
    return "function" == typeof t ? t.apply(void 0, _toConsumableArray(e)) : !!t;
  }
  function bt(t, e) {
    var r = ht({
        context: t.context
      }),
      n = dt(),
      o = vt(),
      a = r.defaultQueryOptions(t);
    a._optimisticResults = n ? "isRestoring" : "optimistic", a.onError && (a.onError = k.batchCalls(a.onError)), a.onSuccess && (a.onSuccess = k.batchCalls(a.onSuccess)), a.onSettled && (a.onSettled = k.batchCalls(a.onSettled)), a.suspense && "number" != typeof a.staleTime && (a.staleTime = 1e3), (a.suspense || a.useErrorBoundary) && (o.isReset() || (a.retryOnMount = !1));
    var _i$useState = i.useState(function () {
        return new e(r, a);
      }),
      _i$useState2 = _slicedToArray(_i$useState, 1),
      u = _i$useState2[0],
      c = u.getOptimisticResult(a);
    if (s.useSyncExternalStore(i.useCallback(function (t) {
      return n ? function () {} : u.subscribe(k.batchCalls(t));
    }, [u, n]), function () {
      return u.getCurrentResult();
    }, function () {
      return u.getCurrentResult();
    }), i.useEffect(function () {
      o.clearReset();
    }, [o]), i.useEffect(function () {
      u.setOptions(a, {
        listeners: !1
      });
    }, [a, u]), a.suspense && c.isLoading && c.isFetching && !n) throw u.fetchOptimistic(a).then(function (_ref5) {
      var t = _ref5.data;
      null == a.onSuccess || a.onSuccess(t), null == a.onSettled || a.onSettled(t, null);
    }).catch(function (t) {
      o.clearReset(), null == a.onError || a.onError(t), null == a.onSettled || a.onSettled(void 0, t);
    });
    if (c.isError && !o.isReset() && !c.isFetching && mt(a.useErrorBoundary, [c.error, u.getCurrentQuery()])) throw c.error;
    return a.notifyOnChangeProps ? c : u.trackResult(c);
  }
  function gt(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var s = ht({
        context: e.context
      }),
      r = i.useRef(e);
    r.current = e, i.useMemo(function () {
      t && ot(s, t, r.current);
    }, [s, t]);
  }
  function Ot() {}
  t.CancelledError = U, t.Hydrate = function (_ref6) {
    var t = _ref6.children,
      e = _ref6.options,
      s = _ref6.state;
    return gt(s, e), t;
  }, t.InfiniteQueryObserver = st, t.IsRestoringProvider = ft, t.MutationCache = G, t.MutationObserver = rt, t.QueriesObserver = et, t.QueryCache = H, t.QueryClient = /*#__PURE__*/function () {
    function _class3() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _classCallCheck(this, _class3);
      this.queryCache = t.queryCache || new H(), this.mutationCache = t.mutationCache || new G(), this.logger = t.logger || K, this.defaultOptions = t.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [];
    }
    _createClass(_class3, [{
      key: "mount",
      value: function mount() {
        var _this36 = this;
        this.unsubscribeFocus = w.subscribe(function () {
          w.isFocused() && (_this36.resumePausedMutations(), _this36.queryCache.onFocus());
        }), this.unsubscribeOnline = F.subscribe(function () {
          F.isOnline() && (_this36.resumePausedMutations(), _this36.queryCache.onOnline());
        });
      }
    }, {
      key: "unmount",
      value: function unmount() {
        var t, e;
        null == (t = this.unsubscribeFocus) || t.call(this), null == (e = this.unsubscribeOnline) || e.call(this);
      }
    }, {
      key: "isFetching",
      value: function isFetching(t, e) {
        var _f5 = f(t, e),
          _f6 = _slicedToArray(_f5, 1),
          s = _f6[0];
        return s.fetchStatus = "fetching", this.queryCache.findAll(s).length;
      }
    }, {
      key: "isMutating",
      value: function isMutating(t) {
        return this.mutationCache.findAll(_objectSpread(_objectSpread({}, t), {}, {
          fetching: !0
        })).length;
      }
    }, {
      key: "getQueryData",
      value: function getQueryData(t, e) {
        var s;
        return null == (s = this.queryCache.find(t, e)) ? void 0 : s.state.data;
      }
    }, {
      key: "getQueriesData",
      value: function getQueriesData(t) {
        return this.getQueryCache().findAll(t).map(function (_ref7) {
          var t = _ref7.queryKey,
            e = _ref7.state;
          return [t, e.data];
        });
      }
    }, {
      key: "setQueryData",
      value: function setQueryData(t, e, s) {
        var r = this.queryCache.find(t),
          i = function (t, e) {
            return "function" == typeof t ? t(e) : t;
          }(e, null == r ? void 0 : r.state.data);
        if (void 0 === i) return;
        var n = l(t),
          o = this.defaultQueryOptions(n);
        return this.queryCache.build(this, o).setData(i, _objectSpread(_objectSpread({}, s), {}, {
          manual: !0
        }));
      }
    }, {
      key: "setQueriesData",
      value: function setQueriesData(t, e, s) {
        var _this37 = this;
        return k.batch(function () {
          return _this37.getQueryCache().findAll(t).map(function (_ref8) {
            var t = _ref8.queryKey;
            return [t, _this37.setQueryData(t, e, s)];
          });
        });
      }
    }, {
      key: "getQueryState",
      value: function getQueryState(t, e) {
        var s;
        return null == (s = this.queryCache.find(t, e)) ? void 0 : s.state;
      }
    }, {
      key: "removeQueries",
      value: function removeQueries(t, e) {
        var _f7 = f(t, e),
          _f8 = _slicedToArray(_f7, 1),
          s = _f8[0],
          r = this.queryCache;
        k.batch(function () {
          r.findAll(s).forEach(function (t) {
            r.remove(t);
          });
        });
      }
    }, {
      key: "resetQueries",
      value: function resetQueries(t, e, s) {
        var _this38 = this;
        var _f9 = f(t, e, s),
          _f10 = _slicedToArray(_f9, 2),
          r = _f10[0],
          i = _f10[1],
          n = this.queryCache,
          o = _objectSpread({
            type: "active"
          }, r);
        return k.batch(function () {
          return n.findAll(r).forEach(function (t) {
            t.reset();
          }), _this38.refetchQueries(o, i);
        });
      }
    }, {
      key: "cancelQueries",
      value: function cancelQueries(t, e, s) {
        var _this39 = this;
        var _f11 = f(t, e, s),
          _f12 = _slicedToArray(_f11, 2),
          r = _f12[0],
          _f12$ = _f12[1],
          i = _f12$ === void 0 ? {} : _f12$;
        void 0 === i.revert && (i.revert = !0);
        var n = k.batch(function () {
          return _this39.queryCache.findAll(r).map(function (t) {
            return t.cancel(i);
          });
        });
        return Promise.all(n).then(a).catch(a);
      }
    }, {
      key: "invalidateQueries",
      value: function invalidateQueries(t, e, s) {
        var _this40 = this;
        var _f13 = f(t, e, s),
          _f14 = _slicedToArray(_f13, 2),
          r = _f14[0],
          i = _f14[1];
        return k.batch(function () {
          var t, e;
          if (_this40.queryCache.findAll(r).forEach(function (t) {
            t.invalidate();
          }), "none" === r.refetchType) return Promise.resolve();
          var s = _objectSpread(_objectSpread({}, r), {}, {
            type: null != (t = null != (e = r.refetchType) ? e : r.type) ? t : "active"
          });
          return _this40.refetchQueries(s, i);
        });
      }
    }, {
      key: "refetchQueries",
      value: function refetchQueries(t, e, s) {
        var _this41 = this;
        var _f15 = f(t, e, s),
          _f16 = _slicedToArray(_f15, 2),
          r = _f16[0],
          i = _f16[1],
          n = k.batch(function () {
            return _this41.queryCache.findAll(r).filter(function (t) {
              return !t.isDisabled();
            }).map(function (t) {
              var e;
              return t.fetch(void 0, _objectSpread(_objectSpread({}, i), {}, {
                cancelRefetch: null == (e = null == i ? void 0 : i.cancelRefetch) || e,
                meta: {
                  refetchPage: r.refetchPage
                }
              }));
            });
          });
        var o = Promise.all(n).then(a);
        return null != i && i.throwOnError || (o = o.catch(a)), o;
      }
    }, {
      key: "fetchQuery",
      value: function fetchQuery(t, e, s) {
        var r = l(t, e, s),
          i = this.defaultQueryOptions(r);
        void 0 === i.retry && (i.retry = !1);
        var n = this.queryCache.build(this, i);
        return n.isStaleByTime(i.staleTime) ? n.fetch(i) : Promise.resolve(n.state.data);
      }
    }, {
      key: "prefetchQuery",
      value: function prefetchQuery(t, e, s) {
        return this.fetchQuery(t, e, s).then(a).catch(a);
      }
    }, {
      key: "fetchInfiniteQuery",
      value: function fetchInfiniteQuery(t, e, s) {
        var r = l(t, e, s);
        return r.behavior = _(), this.fetchQuery(r);
      }
    }, {
      key: "prefetchInfiniteQuery",
      value: function prefetchInfiniteQuery(t, e, s) {
        return this.fetchInfiniteQuery(t, e, s).then(a).catch(a);
      }
    }, {
      key: "resumePausedMutations",
      value: function resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
      }
    }, {
      key: "getQueryCache",
      value: function getQueryCache() {
        return this.queryCache;
      }
    }, {
      key: "getMutationCache",
      value: function getMutationCache() {
        return this.mutationCache;
      }
    }, {
      key: "getLogger",
      value: function getLogger() {
        return this.logger;
      }
    }, {
      key: "getDefaultOptions",
      value: function getDefaultOptions() {
        return this.defaultOptions;
      }
    }, {
      key: "setDefaultOptions",
      value: function setDefaultOptions(t) {
        this.defaultOptions = t;
      }
    }, {
      key: "setQueryDefaults",
      value: function setQueryDefaults(t, e) {
        var s = this.queryDefaults.find(function (e) {
          return b(t) === b(e.queryKey);
        });
        s ? s.defaultOptions = e : this.queryDefaults.push({
          queryKey: t,
          defaultOptions: e
        });
      }
    }, {
      key: "getQueryDefaults",
      value: function getQueryDefaults(t) {
        if (!t) return;
        var e = this.queryDefaults.find(function (e) {
          return g(t, e.queryKey);
        });
        return null == e ? void 0 : e.defaultOptions;
      }
    }, {
      key: "setMutationDefaults",
      value: function setMutationDefaults(t, e) {
        var s = this.mutationDefaults.find(function (e) {
          return b(t) === b(e.mutationKey);
        });
        s ? s.defaultOptions = e : this.mutationDefaults.push({
          mutationKey: t,
          defaultOptions: e
        });
      }
    }, {
      key: "getMutationDefaults",
      value: function getMutationDefaults(t) {
        if (!t) return;
        var e = this.mutationDefaults.find(function (e) {
          return g(t, e.mutationKey);
        });
        return null == e ? void 0 : e.defaultOptions;
      }
    }, {
      key: "defaultQueryOptions",
      value: function defaultQueryOptions(t) {
        if (null != t && t._defaulted) return t;
        var e = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.defaultOptions.queries), this.getQueryDefaults(null == t ? void 0 : t.queryKey)), t), {}, {
          _defaulted: !0
        });
        return !e.queryHash && e.queryKey && (e.queryHash = m(e.queryKey, e)), void 0 === e.refetchOnReconnect && (e.refetchOnReconnect = "always" !== e.networkMode), void 0 === e.useErrorBoundary && (e.useErrorBoundary = !!e.suspense), e;
      }
    }, {
      key: "defaultMutationOptions",
      value: function defaultMutationOptions(t) {
        return null != t && t._defaulted ? t : _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.defaultOptions.mutations), this.getMutationDefaults(null == t ? void 0 : t.mutationKey)), t), {}, {
          _defaulted: !0
        });
      }
    }, {
      key: "clear",
      value: function clear() {
        this.queryCache.clear(), this.mutationCache.clear();
      }
    }]);
    return _class3;
  }(), t.QueryClientProvider = function (_ref9) {
    var t = _ref9.client,
      e = _ref9.children,
      s = _ref9.context,
      _ref9$contextSharing = _ref9.contextSharing,
      r = _ref9$contextSharing === void 0 ? !1 : _ref9$contextSharing;
    i.useEffect(function () {
      return t.mount(), function () {
        t.unmount();
      };
    }, [t]);
    var n = ct(s, r);
    return i.createElement(ut.Provider, {
      value: !s && r
    }, i.createElement(n.Provider, {
      value: t
    }, e));
  }, t.QueryErrorResetBoundary = function (_ref10) {
    var t = _ref10.children;
    var _i$useState3 = i.useState(function () {
        return pt();
      }),
      _i$useState4 = _slicedToArray(_i$useState3, 1),
      e = _i$useState4[0];
    return i.createElement(yt.Provider, {
      value: e
    }, "function" == typeof t ? t(e) : t);
  }, t.QueryObserver = X, t.defaultContext = at, t.dehydrate = function (t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var s = [],
      r = [];
    if (!1 !== e.dehydrateMutations) {
      var _r3 = e.shouldDehydrateMutation || it;
      t.getMutationCache().getAll().forEach(function (t) {
        _r3(t) && s.push(function (t) {
          return {
            mutationKey: t.options.mutationKey,
            state: t.state
          };
        }(t));
      });
    }
    if (!1 !== e.dehydrateQueries) {
      var _s6 = e.shouldDehydrateQuery || nt;
      t.getQueryCache().getAll().forEach(function (t) {
        _s6(t) && r.push(function (t) {
          return {
            state: t.state,
            queryKey: t.queryKey,
            queryHash: t.queryHash
          };
        }(t));
      });
    }
    return {
      mutations: s,
      queries: r
    };
  }, t.focusManager = w, t.hashQueryKey = b, t.hydrate = ot, t.isCancelledError = I, t.isError = function (t) {
    return t instanceof Error;
  }, t.notifyManager = k, t.onlineManager = F, t.parseFilterArgs = f, t.parseMutationArgs = d, t.parseMutationFilterArgs = p, t.parseQueryArgs = l, t.useHydrate = gt, t.useInfiniteQuery = function (t, e, s) {
    return bt(l(t, e, s), st);
  }, t.useIsFetching = function (t, e, r) {
    var _f17 = f(t, e, r),
      _f18 = _slicedToArray(_f17, 2),
      n = _f18[0],
      _f18$ = _f18[1],
      o = _f18$ === void 0 ? {} : _f18$,
      a = ht({
        context: o.context
      }),
      u = a.getQueryCache();
    return s.useSyncExternalStore(i.useCallback(function (t) {
      return u.subscribe(k.batchCalls(t));
    }, [u]), function () {
      return a.isFetching(n);
    }, function () {
      return a.isFetching(n);
    });
  }, t.useIsMutating = function (t, e, r) {
    var _p = p(t, e, r),
      _p2 = _slicedToArray(_p, 2),
      n = _p2[0],
      _p2$ = _p2[1],
      o = _p2$ === void 0 ? {} : _p2$,
      a = ht({
        context: o.context
      }),
      u = a.getMutationCache();
    return s.useSyncExternalStore(i.useCallback(function (t) {
      return u.subscribe(k.batchCalls(t));
    }, [u]), function () {
      return a.isMutating(n);
    }, function () {
      return a.isMutating(n);
    });
  }, t.useIsRestoring = dt, t.useMutation = function (t, e, r) {
    var n = d(t, e, r),
      o = ht({
        context: n.context
      }),
      _i$useState5 = i.useState(function () {
        return new rt(o, n);
      }),
      _i$useState6 = _slicedToArray(_i$useState5, 1),
      a = _i$useState6[0];
    i.useEffect(function () {
      a.setOptions(n);
    }, [a, n]);
    var u = s.useSyncExternalStore(i.useCallback(function (t) {
        return a.subscribe(k.batchCalls(t));
      }, [a]), function () {
        return a.getCurrentResult();
      }, function () {
        return a.getCurrentResult();
      }),
      c = i.useCallback(function (t, e) {
        a.mutate(t, e).catch(Ot);
      }, [a]);
    if (u.error && mt(a.options.useErrorBoundary, [u.error])) throw u.error;
    return _objectSpread(_objectSpread({}, u), {}, {
      mutate: c,
      mutateAsync: u.mutate
    });
  }, t.useQueries = function (_ref11) {
    var t = _ref11.queries,
      e = _ref11.context;
    var r = ht({
        context: e
      }),
      n = dt(),
      o = i.useMemo(function () {
        return t.map(function (t) {
          var e = r.defaultQueryOptions(t);
          return e._optimisticResults = n ? "isRestoring" : "optimistic", e;
        });
      }, [t, r, n]),
      _i$useState7 = i.useState(function () {
        return new et(r, o);
      }),
      _i$useState8 = _slicedToArray(_i$useState7, 1),
      a = _i$useState8[0],
      u = a.getOptimisticResult(o);
    return s.useSyncExternalStore(i.useCallback(function (t) {
      return n ? function () {} : a.subscribe(k.batchCalls(t));
    }, [a, n]), function () {
      return a.getCurrentResult();
    }, function () {
      return a.getCurrentResult();
    }), i.useEffect(function () {
      a.setQueries(o, {
        listeners: !1
      });
    }, [o, a]), u;
  }, t.useQuery = function (t, e, s) {
    return bt(l(t, e, s), X);
  }, t.useQueryClient = ht, t.useQueryErrorResetBoundary = vt, Object.defineProperty(t, "__esModule", {
    value: !0
  });
});